import { formatDate } from '@fukuri-admins/utils/common/date';
import { useRemindModal } from './hooks';
import { RemindModalPresentation } from './presentations';

type Props = {
  threeLetterCode: string;
  stressAssessmentId: number;
  onClose: () => void;
};

export const RemindModal: React.FC<Props> = ({ threeLetterCode, stressAssessmentId, onClose }) => {
  const { handleRemind, dueDate, pendingCount } = useRemindModal({
    threeLetterCode,
    stressAssessmentId,
  });

  const dueDateLabel = dueDate
    ? formatDate({ date: new Date(dueDate * 1000), formatType: 'yyyy/MM/dd' })
    : '-';

  return (
    <RemindModalPresentation
      pendingCount={pendingCount}
      dueDateLabel={dueDateLabel}
      onClose={onClose}
      onConfirm={handleRemind}
    />
  );
};
